import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpEvent,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '@shared/services/storage.service';

@Injectable()
export class HttpResponseInterceptor implements HttpInterceptor {
  constructor(private router: Router, private toaster: ToastrService,private storageService:StorageService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const errors = error?.error?.errors;
          let firstMessage = 'Unauthenticated';
          if (Array.isArray(errors) && errors.length > 0 && Array.isArray(errors[0]?.errors)) {
            firstMessage = errors[0].errors.join(' ');
          }
          this.toaster.error(firstMessage, 'Error');
          this.storageService.removeAll();
          this.router.navigate(['/login']);
        }
       else if (error.status === 422) {
          const errors = error?.error?.errors;
          for (const error of errors) {
            if (error.field !== 'old_password') {
            this.toaster.error(`${error.errors.join(' ')}`, 'Error');
            }
          }
        } else if (error.status === 500) {
          const errors = error?.error?.errors;
          if (errors) {
            for (const error of errors) {
              //this.toaster.error(`${error.errors.join(' ')}`,"Error");
            }
          }
          if (!errors) this.toaster.error(`Internal Server Error`, 'Error');
        } else if (error.status === 403) {
          this.toaster.error(error.error.errors[0].errors[0], error.statusText);
          const returnUrl = '/';
          this.router.navigate([returnUrl]);
        }
        if (error.error && error.error.app_path) {
          console.warn('Error with app_path detected, suppressing toaster notification.');
        } else if (error.status === 404) {
          this.toaster.error(error.error.errors[0].errors[0], 'Error');
        }
        return throwError(error);
      })
    );
  }
}
